import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-l-4 border-[#E5E7EB] border-l-[#F59E0B] bg-[#F8FAFC] px-5 py-4 shadow-[0px_1px_3px_rgba(0,0,0,0.05),0px_1px_2px_rgba(0,0,0,0.03)]" }
const _hoisted_2 = { class: "flex items-start gap-4" }
const _hoisted_3 = { class: "flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-[#E5E7EB] bg-white text-[#D97706] shadow-sm" }
const _hoisted_4 = { class: "min-w-0 flex-1" }
const _hoisted_5 = { class: "mt-3.5 flex flex-wrap items-center gap-2" }
const _hoisted_6 = { class: "flex items-center gap-1.5 rounded-full border border-[#E5E7EB] bg-white px-3 py-1 text-xs shadow-sm" }
const _hoisted_7 = { class: "font-semibold text-[#242B59]" }
const _hoisted_8 = { class: "flex items-center gap-1.5 rounded-full border border-[#E5E7EB] bg-white px-3 py-1 text-xs shadow-sm" }
const _hoisted_9 = { class: "font-semibold text-[#242B59]" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2.5 text-xs italic text-[#737373]"
}

import { ClockIcon, XIcon } from '@heroicons/vue/solid';

interface TemporalConflict {
    questionPeriod: string;
    filterPeriod: string;
    details?: string;
    suggestedDateFrom?: string;
    suggestedDateTo?: string;
}

interface Props {
    conflict: TemporalConflict;
    dismissible?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TemporalWarning',
  props: {
    conflict: {},
    dismissible: { type: Boolean, default: true }
  },
  emits: ["auto-correct", "manual-edit", "proceed", "rephrase", "dismiss"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const onAutoCorrect = () => emit('auto-correct');
const onManualEdit = () => emit('manual-edit');
const onProceed = () => emit('proceed');
const onRephrase = () => emit('rephrase');
const onDismiss = () => emit('dismiss');

const RELATIVE_PERIOD_LABELS: Record<string, string> = {
    today: 'hoje',
    yesterday: 'ontem',
    day_before_yesterday: 'anteontem',
};

function formatDate(dateString: string): string {
    const parsed = new Date(dateString);
    if (Number.isNaN(parsed.getTime())) {
        return dateString;
    }

    return parsed.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC',
    });
}

function formatDateTimeRange(value: string): string {
    const parts = value.split(' - ').map((item) => item.trim());
    if (parts.length === 2) {
        return `${formatDate(parts[0])} a ${formatDate(parts[1])}`;
    }

    const isoRange = value.split(' to ').map((item) => item.trim());
    if (isoRange.length === 2) {
        return `${formatDate(isoRange[0])} a ${formatDate(isoRange[1])}`;
    }

    return formatDate(value);
}

function formatQuestionPeriod(value: string): string {
    const normalized = String(value || '')
        .trim()
        .toLowerCase();
    if (!normalized) {
        return '-';
    }

    if (RELATIVE_PERIOD_LABELS[normalized]) {
        return RELATIVE_PERIOD_LABELS[normalized];
    }

    return formatDateTimeRange(value);
}

function formatFilterPeriod(value: string): string {
    if (!value) {
        return '-';
    }

    return formatDateTimeRange(value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(ClockIcon), { class: "h-5 w-5" })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"mb-1.5 flex flex-wrap items-center gap-2\"><span class=\"text-[10px] font-bold uppercase tracking-wider text-[#737373]\"> Período em conflito </span><span class=\"rounded bg-[#FEF3C7] px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-[#D97706]\"> ajuste necessário </span></div><p class=\"text-sm font-semibold text-[#242B59]\"> A pergunta pede um período diferente do filtro ativo. </p><p class=\"mt-1 text-xs leading-relaxed text-[#626468]\"> Revise o intervalo antes de seguir para evitar resposta inconsistente. </p>", 3)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "font-bold text-[#737373]" }, "Pergunta:", -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(formatQuestionPeriod(_ctx.conflict.questionPeriod)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-bold text-[#737373]" }, "Filtro:", -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(formatFilterPeriod(_ctx.conflict.filterPeriod)), 1)
          ])
        ]),
        (_ctx.conflict.details)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.conflict.details), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", { class: "mt-4 flex flex-wrap items-center gap-2" }, [
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center gap-1.5 rounded-xl bg-[#48DDC3] px-3.5 py-2 text-xs font-bold text-[#242B59] shadow-sm transition-all hover:bg-[#3bc4ab] focus:outline-none focus:ring-2 focus:ring-[#48DDC3]/50",
            onClick: onAutoCorrect
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("svg", {
              class: "h-3.5 w-3.5",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2.5"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M13 10V3L4 14h7v7l9-11h-7z"
              })
            ], -1),
            _createTextVNode(" Corrigir automaticamente ", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center gap-1.5 rounded-xl border border-[#E5E7EB] bg-white px-3.5 py-2 text-xs font-semibold text-[#626468] shadow-sm transition-all hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-200",
            onClick: onManualEdit
          }, _cache[3] || (_cache[3] = [
            _createElementVNode("svg", {
              class: "h-3.5 w-3.5 text-gray-400",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              })
            ], -1),
            _createTextVNode(" Editar período ", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center gap-1.5 rounded-xl border border-[#E5E7EB] bg-white px-3.5 py-2 text-xs font-semibold text-[#626468] shadow-sm transition-all hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-200",
            onClick: onProceed
          }, _cache[4] || (_cache[4] = [
            _createElementVNode("svg", {
              class: "h-3.5 w-3.5 text-gray-400",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              })
            ], -1),
            _createTextVNode(" Manter filtros ", -1)
          ])),
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex items-center gap-1.5 rounded-xl border border-[#E5E7EB] bg-white px-3.5 py-2 text-xs font-semibold text-[#626468] shadow-sm transition-all hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-200",
            onClick: onRephrase
          }, _cache[5] || (_cache[5] = [
            _createElementVNode("svg", {
              class: "h-3.5 w-3.5 text-gray-400",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor",
              "stroke-width": "2"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              })
            ], -1),
            _createTextVNode(" Reformular pergunta ", -1)
          ]))
        ])
      ]),
      (_ctx.dismissible)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rounded-lg p-1 text-[#A3A3A3] transition-colors hover:bg-black/5",
            onClick: onDismiss
          }, [
            _createVNode(_unref(XIcon), { class: "h-5 w-5" })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})